"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reduceImageFromUrl = void 0;
const reduceImageFromUrl = (image, size) => {
    if (image) {
        if (image.includes('boticario.vteximg.com.br')) {
            image = image.replace('500-500', `${size}-${size}`);
        }
        else if (image.includes('res.cloudinary.com')) {
            image = image.replace('upload/f_auto', `upload/w_${size},h_${size},f_auto`);
            image = image.replace('q_auto:best/v1', 'q_auto:good/v1');
        }
    }
    return image;
};
exports.reduceImageFromUrl = reduceImageFromUrl;
